// @ts-nocheck
import React, { useState, useEffect, useRef } from 'react';

import { Card, InfoBanner, Th, Td } from '../../../components/WorkflowFormPrimitives';
import { fmt } from '../../../utils/formatCurrency';
import { useCompanyContext } from '../../../context/CompanyContext';
import { PARACHUTE_STEP_INFO } from '../parachuteCopy';
import { getUniqueIndividualsFromForm } from './uniqueIndividuals';

export const CompIncreasesContent = ({ formData, setFormData }) => {
  const { currentAnalysisId } = useCompanyContext();
  const uniqueIndividuals = getUniqueIndividualsFromForm(formData);
  const [data, setData] = useState(formData.compIncreaseData || {});
  const lastIncomingCompIncJson = useRef(null);

  useEffect(() => {
    lastIncomingCompIncJson.current = null;
  }, [currentAnalysisId]);

  useEffect(() => {
    const incoming = formData.compIncreaseData || {};
    const json = JSON.stringify(incoming);
    if (lastIncomingCompIncJson.current !== json) {
      lastIncomingCompIncJson.current = json;
      setData(incoming);
    }
  }, [formData.compIncreaseData]);

  const update = (id, k, v) => setData((p) => ({ ...p, [id]: { ...p[id], [k]: v } }));
  const calcDifference = (ind) => {
    const d = data[ind.id] || {};
    const comp = formData.compensation?.[ind.id] || {};
    if (d.hasIncrease !== 'yes') return 0;
    const currentTotal = (+comp.baseSalary || 0) * (1 + (+comp.bonusPct || 0));
    const priorTotal = (+d.priorBaseSalary || 0) * (1 + (+d.priorBonusPct || 0));
    return Math.max(0, currentTotal - priorTotal);
  };
  useEffect(() => {
    setFormData((p) => ({ ...p, compIncreaseData: data }));
  }, [data]);

  return (
    <div className="space-y-3">
      <Card padding={false}>
        <table className="w-full">
          <thead className="bg-gray-50 border-b border-gray-200">
            <tr>
              <Th>Name</Th>
              <Th>Recent Increase?</Th>
              <Th>Current Base</Th>
              <Th>Current Bonus %</Th>
              <Th>Prior Base Salary</Th>
              <Th>Prior Bonus %</Th>
              <Th className="bg-emerald-50/50">Difference</Th>
              <Th className="bg-emerald-50/50">Parachute value</Th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {uniqueIndividuals.map((ind) => {
              const d = data[ind.id] || {};
              const comp = formData.compensation?.[ind.id] || {};
              const hasIncrease = d.hasIncrease === 'yes';
              const diff = calcDifference(ind);
              return (
                <tr key={ind.id} className="hover:bg-gray-50/50">
                  <Td highlight>
                    <div>
                      <span className="text-gray-900">{ind.name}</span>
                      <br />
                      <span className="text-xs text-gray-400">{ind.title}</span>
                    </div>
                  </Td>
                  <Td>
                    <select
                      value={d.hasIncrease || 'no'}
                      onChange={(e) => update(ind.id, 'hasIncrease', e.target.value)}
                      className="h-8 px-2 text-xs border border-gray-300 rounded-md"
                    >
                      <option value="no">No</option>
                      <option value="yes">Yes</option>
                    </select>
                  </Td>
                  <Td className="text-gray-400">{hasIncrease ? fmt(comp.baseSalary || 0) : '—'}</Td>
                  <Td className="text-gray-400">{hasIncrease ? `${((comp.bonusPct || 0) * 100).toFixed(0)}%` : '—'}</Td>
                  <Td>
                    {hasIncrease ? (
                      <input
                        type="number"
                        value={d.priorBaseSalary || ''}
                        onChange={(e) => update(ind.id, 'priorBaseSalary', e.target.value)}
                        className="w-28 h-8 px-2 text-xs border border-gray-300 rounded-md"
                        placeholder="0"
                      />
                    ) : (
                      <span className="text-gray-300">—</span>
                    )}
                  </Td>
                  <Td>
                    {hasIncrease ? (
                      <div className="flex items-center gap-0.5">
                        <input
                          type="text"
                          inputMode="decimal"
                          value={
                            d.priorBonusPct !== '' && d.priorBonusPct != null
                              ? String(Number(d.priorBonusPct) * 100)
                              : ''
                          }
                          onChange={(e) => {
                            const raw = e.target.value.replace(/%/g, '').trim();
                            if (raw === '') {
                              update(ind.id, 'priorBonusPct', '');
                              return;
                            }
                            const num = parseFloat(raw);
                            if (!Number.isNaN(num)) update(ind.id, 'priorBonusPct', String(num / 100));
                          }}
                          className="w-16 h-8 px-2 text-xs border border-gray-300 rounded-md"
                          placeholder="20"
                        />
                        <span className="text-xs text-gray-500">%</span>
                      </div>
                    ) : (
                      <span className="text-gray-300">—</span>
                    )}
                  </Td>
                  <Td className="bg-emerald-50/30 text-emerald-700">{hasIncrease ? fmt(diff) : '—'}</Td>
                  <Td className="bg-emerald-50/30 font-bold text-emerald-700">{hasIncrease ? fmt(diff) : '—'}</Td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </Card>
      <InfoBanner variant="warning" showIcon>
        <strong>Compensation increases:</strong> {PARACHUTE_STEP_INFO.compIncreases}
      </InfoBanner>
    </div>
  );
};
